/** Returns an array that can be spread to include the filter parameter value(s) */
export const stringToArray = (param?: string | string[]) => {
  if (param) {
    if (Array.isArray(param)) {
      return param;
    }
    return [param];
  }
  return [];
};
